import { useState } from "react";
import type { ReactElement } from "react";
import { Drawer } from "antd";
import type { CatalogRecord } from "@/types/shopCatalog";
import { CatalogManager } from "../catalog/CatalogManager";

export default function Specification(): ReactElement {
  const [spec, setSpec] = useState<CatalogRecord | null>(null);
  return <>
    <CatalogManager kind="spec" onManageValues={setSpec} />
    <Drawer title={`${spec?.specName ?? ""} · 规格值`} open={spec !== null} onClose={() => setSpec(null)} width="85%" destroyOnHidden>
      {spec && <CatalogManager key={spec.id} kind="specValue" parentSpec={spec} />}
    </Drawer>
  </>;
}
